export const SET_BANK_ACCOUNTS = "BANK_ACCOUNTS_SET_BANK_ACCOUNTS";
export const SET_ERROR = "BANK_ACCOUNTS_SET_ERROR";
export const SET_FETCHING = "BANK_ACCOUNTS_SET_FETCHING";
